import { render, staticRenderFns } from "./SupportCommunications.vue?vue&type=template&id=3f3d5501&scoped=true&"
import script from "./SupportCommunications.vue?vue&type=script&lang=js&"
export * from "./SupportCommunications.vue?vue&type=script&lang=js&"
import style0 from "./SupportCommunications.vue?vue&type=style&index=0&id=3f3d5501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d5501",
  null
  
)

export default component.exports